import { render, staticRenderFns } from "./BulkLandStatement.vue?vue&type=template&id=1a0e32a2&"
import script from "./BulkLandStatement.vue?vue&type=script&lang=js&"
export * from "./BulkLandStatement.vue?vue&type=script&lang=js&"
import style0 from "./BulkLandStatement.vue?vue&type=style&index=0&id=1a0e32a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports